export const ESTABLISHED_YEAR_MIN = 1900;

export function buildEstablishedYearOptions(currentYear = new Date().getFullYear()) {
  const start = Number(currentYear) || new Date().getFullYear();
  const options = [];
  for (let year = start; year >= ESTABLISHED_YEAR_MIN; year -= 1) {
    options.push({ value: year, label: String(year) });
  }
  return options;
}
